import Vue from 'vue'

export async function getAddressAllAdcode (code) {
  const res1 = await Vue.prototype.$tkParse.get(
    `https://open-api.mokecloud.com/region?code=${code}`
  )
  const cityCode = res1.data[0].pcode
  const res2 = await Vue.prototype.$tkParse.get(
    `https://open-api.mokecloud.com/region?code=${cityCode}`
  )
  const provinceCode = res2.data[0].pcode
  return { cityCode, provinceCode }
}
